export const obtecPanels = {
  economico: {
    label: 'BI Econômico Estadual',
    subtitle: 'Visão estratégica do comércio amazonense',
    action: 'Acessar Painel Econômico',
    icon: '/assets/Icon/f3607da8-e8dc-43a7-873f-4e497f6bd02f.png',
    url: 'https://app.powerbi.com/view?r=eyJrIjoiZjM5M2QzMGEtYWJlNC00ODgwLTk3OTUtOTJhOGNiZDhmNjQ4IiwidCI6IjJiZmM4YzU1LWRmNzQtNGI5NC1hODVhLTc4MzZjMjk5MTFiOCJ9',
  },
  digital: {
    label: 'BI Transformação Digital',
    subtitle: 'Tecnologia e inovação do comércio',
    action: 'Acessar Painel Digital',
    icon: '/assets/Icon/bc5c0ec7-ec66-49e2-9f0f-4297cdbce441-Photoroom.png',
    url: 'https://app.powerbi.com/view?r=eyJrIjoiMjg5ZGFkMzMtM2YwNS00NDgxLTllZDktZjYyZDRmMzIyNGI4IiwidCI6IjJiZmM4YzU1LWRmNzQtNGI5NC1hODVhLTc4MzZjMjk5MTFiOCJ9',
  },
} as const;

export type ObtecPanelKey = keyof typeof obtecPanels;

export const obtecPanelPath = (panel: ObtecPanelKey) =>
  `/pesquisa-inovacao/obtec/painel-inteligencia?painel=${panel}`;
